// components/orders/PrintLabelDocument.jsx
import React from 'react';

const PAYMENT_METHOD_LABEL = { khqr: 'KHQR', alipay: '支付寶', usdt: 'USDT', cod: '貨到付款' };

const PrintLabelDocument = ({ order }) => {
  if (!order) return null;

  return (
    <div id="print-label-area" className="print-label">
      <div className="label-shop-name">{order.shop_name || '訂單面單'}</div>

      <div className="label-order-no">{order.order_no}</div>

      <div className="label-divider" />

      <div className="label-section">
        <div className="label-row-title">收件資訊</div>
        <div className="label-contact">{order.customer_name || '客戶'}　{order.customer_phone}</div>
        <div className="label-address">{order.delivery_address}</div>
      </div>

      <div className="label-divider" />

      <div className="label-section">
        <div className="label-row-title">商品明細</div>
        {order.items?.map(item => (
          <div key={item.id} className="label-item-row">
            <span className="item-name">{item.product_name}</span>
            <span className="item-qty">x{item.quantity}</span>
          </div>
        ))}
      </div>

      <div className="label-divider" />

      <div className="label-footer-row">
        <span>合計</span>
        <span className="label-total">${parseFloat(order.total_amount).toFixed(2)}</span>
      </div>
      <div className="label-footer-row">
        <span>付款方式</span>
        <span className={order.payment_status === 'paid' || order.payment_method === 'cod' ? 'label-paid' : 'label-unpaid'}>
          {order.payment_method === 'cod'
            ? '貨到付款（現場收款）'
            : `${PAYMENT_METHOD_LABEL[order.payment_method] || order.payment_method}（已付款）`}
        </span>
      </div>

      {order.notes && (
        <div className="label-notes">備註：{order.notes}</div>
      )}

      <div className="label-time">{new Date(order.created_at).toLocaleString('zh-CN')}</div>
    </div>
  );
};

export default PrintLabelDocument;